<button
  *ngIf="(hasReminder$ | async); else noReminder"
  class="button toolbar-icon"
  data-test-selector="op-wp-reminder-button"
  [attr.title]="buttonTitle"
  (click)="openModal()"
>
  <svg op-alarm-set-icon class="button--icon" size="small"></svg>
</button>

<ng-template #noReminder>
  <button
    class="button toolbar-icon"
    data-test-selector="op-wp-reminder-button"
    [attr.title]="buttonTitle"
    wpReminderContextMenu
    [wpReminderContextMenu-workPackage]="workPackage"
  >
    <svg op-alarm-icon class="button--icon" size="small"></svg>
  </button>
</ng-template>
